import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 本当に削除してよろしいですか？ ")

import { ref, computed } from 'vue'
import ModalWindow from '@/components/ModalWindow.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonDelete',
  props: {
  size: { type: String, default: '' },
  dialogTitle: { type: String, default: '削除確認' }
},
  emits: ["deleteConfirmed"],
  setup(__props, { emit }: { emit: ({
  (event: 'deleteConfirmed'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props



// eslint-disable-next-line func-call-spacing


const buttonClasses = computed(() => [
  'btn btn-danger',
  {
    [`btn-${props.size}`]: props.size
  }
])

const isConfirm = ref(false)
const confirm = () => {
  emit('deleteConfirmed')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", _mergeProps(_ctx.$attrs, {
      type: "button",
      class: _unref(buttonClasses),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isConfirm.value = true))
    }), " 削除 ", 16),
    _createVNode(ModalWindow, {
      modelValue: isConfirm.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isConfirm).value = $event)),
      title: __props.dialogTitle,
      "ok-title": "削除する",
      "ok-variant": "danger",
      onOk: confirm
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})